import { useState } from "react";
import { PrimaryButton } from "../../../components/Buttons";
import { colors } from "../../../components/colors";
import { AddVoucherToUserModal } from "./AddVoucherToUserModal";

type Props = {
  voucherId?: string;
  userId: string;
};

export const AddVoucherToUserSelector = (props: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <PrimaryButton
        type="button"
        hoverColor={colors.ctaLight}
        color={colors.ctaMain}
        backgroundColor={colors.white}
        onClick={() => {
          setModalOpen(true);
        }}
        className="w-fit"
      >
        Add voucher
      </PrimaryButton>
      <AddVoucherToUserModal
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        {...props}
      />
    </div>
  );
};
